function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  iconButton: {
    color: "inherit"
  },
  icon: {
    fontSize: "18px",
    "& + $label": {
      marginLeft: theme.spacing(.5)
    }
  },
  button: {
    padding: theme.spacing(1),
    borderRadius: 0,
    minWidth: 0
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    fontWeight: "bold",
    lineHeight: "1",
    textTransform: "uppercase"
  }
}));

const ButtonAction = (_ref) => {
  let name = _ref.name,
      value = _ref.value,
      icon = _ref.icon,
      label = _ref.label,
      options = _ref.options,
      disabled = _ref.disabled,
      color = _ref.color,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "value", "icon", "label", "options", "disabled", "color", "onClick"]);

  const classes = useStyles();

  if (icon && label) {
    return React.createElement(Button, {
      className: classes.button,
      name: name,
      value: value,
      disabled: disabled,
      color: color,
      onClick: onClick
    }, React.createElement(Icon, {
      className: classes.icon
    }, icon), React.createElement("b", {
      className: classes.label
    }, label));
  }

  if (icon) {
    return React.createElement(IconButton, {
      className: classes.iconButton,
      name: name,
      value: value,
      disabled: disabled,
      color: color,
      onClick: onClick
    }, React.createElement(Icon, {
      className: classes.icon
    }, icon));
  }

  return React.createElement(Button, {
    className: classes.button,
    name: name,
    value: value,
    disabled: disabled,
    color: color,
    onClick: onClick
  }, React.createElement("b", {
    className: classes.label
  }, label));
};

export default ButtonAction;